import { z } from "zod";

import { appLocaleSchema } from "../auth/auth";
import { E164, phoneSchema } from "./messaging-contacts";

/**
 * Super-admin probe: send one fake incident over the WhatsApp Cloud API.
 *
 * Independent of the platform WhatsApp switch and of the consent table. Cloud
 * credentials must still be present. No incident row is written; the point
 * is to prove the token, the sender and the approved template (ADR-099).
 */
export const testIncidentWhatsAppRequestSchema = z.object({
  /**
   * Bare E.164 after punctuation is stripped. Required: a super admin has
   * no phone on the account, so there is nothing to default to.
   */
  to: phoneSchema,
  /** Which approved template language to send. Defaults to es-AR. */
  locale: appLocaleSchema.optional(),
});

export type TestIncidentWhatsAppRequest = z.infer<typeof testIncidentWhatsAppRequestSchema>;

export const testIncidentWhatsAppResponseSchema = z.object({
  delivered: z.boolean(),
  /** Number Meta was asked to message, in bare E.164. */
  to: z.string().regex(E164),
  /** Approved template name. Wording lives in Meta, not in this response. */
  template: z.string().min(1),
  /** Meta language code, such as `es_AR` or `en_GB`. */
  language: z.string().min(1),
  /**
   * Sanitized provider error when `delivered` is false.
   * Never the access token.
   */
  error: z.string().min(1).optional(),
});

export type TestIncidentWhatsAppResponse = z.infer<typeof testIncidentWhatsAppResponseSchema>;
